import React, { useState } from "react";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppText } from "src/commun/composants/AppText";
import AdminServicesForm from "src/pages/admin/adminservices/AdminServicesForm";
import AdminPubliciteForm from "src/pages/admin/adminpublicite/AdminPubliciteForm";
import AdminAccessGroupForm from "src/pages/admin/adminAccessGroup/AdminAccessGroupForm";
import { useAppState } from "src/app/state/StateProvider";


type pointMenu = "" | "service" | "publicite" | "groupes";


const AdminContainer = () => {
  const [adminSelect, setadminSelect] = useState<pointMenu>("");
  const { tString } = useAppText();

  const [{ user }] = useAppState();

  if(!user?.admin) return <></>
  return <><AppRow> <AppCol md={{ span: 2,offset:4 }}>


    <input
      className="btn__primary mt-3 btn--full--xs btn btn-nm btn-primary "
      type="button"
      name="submit"
      onClick={() => setadminSelect("service")}
      value={tString("admin.administrer.service")}
    />

  </AppCol
  ><AppCol md={{ span: 2 }}>


    <input
      className="btn__primary mt-3 btn--full--xs btn btn-nm btn-primary "
      type="button"
      name="submit"
      onClick={() => setadminSelect("publicite")}
      value={tString("admin.administrer.publicite")}
    />

  </AppCol
  >
    <AppCol md={{ span: 2 }}>


      <input
        className="btn__primary mt-3 btn--full--xs btn btn-nm btn-primary "
        type="button"
        name="submit"
        onClick={() => setadminSelect("groupes")}
        value={tString("admin.administrer.groupes")}
      />
    </AppCol
    ></AppRow>
    <AppRow>
      <AppCol>
        {(adminSelect === "service") && <AdminServicesForm/>}
        {(adminSelect === "publicite") && <AdminPubliciteForm/>}
        {(adminSelect === "groupes") && <AdminAccessGroupForm/>}
      </AppCol>
    </AppRow>
  </>;

};

export default AdminContainer;